// services/version.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface AppVersion {
    version: string;
    buildDate: string;
    buildHash: string;
}

@Injectable({
    providedIn: 'root',
})
export class AppVersionService {
    private readonly STORAGE_KEY = 'app-version';

    constructor(private http: HttpClient) {}

    /**
     * 📥 Charger et stocker la version depuis version.json
     */
    async loadAndStoreVersion(): Promise<AppVersion> {
        const cacheBuster = Date.now();

        const headers = new HttpHeaders({
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
        });

        try {
            const version = await firstValueFrom(
                this.http.get<AppVersion>(
                    `/assets/version.json?v=${cacheBuster}`,
                    { headers }
                )
            );

            // Stocker dans localStorage
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(version));

            console.log('✅ Version chargée et stockée:', version);
            return version;
        } catch (error) {
            console.error('❌ Erreur chargement version:', error);
            throw error;
        }
    }

    /**
     * 📖 Lire la version depuis localStorage
     */
    getStoredVersion(): AppVersion | null {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            console.error('❌ Erreur lecture version:', error);
            return null;
        }
    }

    /**
     * 🗑️ Supprimer la version stockée
     */
    clearStoredVersion(): void {
        localStorage.removeItem(this.STORAGE_KEY);
        console.log('🗑️ Version supprimée du storage');
    }

    /**
     * 🔄 Recharger la version (force refresh)
     */
    async reloadVersion(): Promise<AppVersion> {
        this.clearStoredVersion();
        return await this.loadAndStoreVersion();
    }
}
